import { cva, type VariantProps } from 'class-variance-authority'

import IconAlert from '@images/icons/circle-warning.svg'
import IconCheck from '@images/icons/circle-check.svg'
import IconInfo from '@images/icons/circle-info.svg'
import { cn } from '@lib/cn'

const alertVariants = cva('flex w-full gap-2.5 rounded-xl px-4 py-3 text-[13px] leading-5 [&>svg]:mt-0.5 [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:fill-current', {
  variants: {
    variant: {
      info: 'bg-o-soft text-o-slate [&>svg]:text-o-muted',
      success: 'bg-o-success-bg text-o-success',
      warning: 'bg-o-notice-bg text-o-notice [&>svg]:text-o-amber',
      danger: 'bg-o-danger-bg text-o-danger'
    }
  },
  defaultVariants: { variant: 'info' }
})

const icons = {
  info: IconInfo,
  success: IconCheck,
  warning: IconAlert,
  danger: IconAlert
}

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>, VariantProps<typeof alertVariants> {
  title?: React.ReactNode
}

const Alert = ({ className, variant = 'info', title, children, ...props }: Props) => {
  const Icon = icons[variant ?? 'info']

  return (
    <div role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
      <Icon />
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        {title && <p className="font-medium">{title}</p>}
        <div>{children}</div>
      </div>
    </div>
  )
}

export default Alert
